"use client";

import { useDraftMode } from "@/components/ui/DraftmodeContext";
import { InitialLink } from "./routing";
import { env } from "@/env.mjs";

export const Link: typeof InitialLink = ({ prefetch, ...props }) => {
	const isEnabled = useDraftMode();

	const disablePrefetch = isEnabled || env.NEXT_PUBLIC_IS_STAGING;

	return <InitialLink {...props} prefetch={disablePrefetch ? false : prefetch} />;
};
